import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface FilterConfigState {
  favorites: boolean, 
  type: string[], 
  status: string[],
  incidence: number[],
  setFavorites: (option: boolean) => void;
  setType: (type: string) => void;
  setStatus: (status: string) => void;
  setIncidence: (incidence: number) => void;
  resetFilters: () => void;
  resetOnChange: () => void;
}

export const useFilterConfigStore = create<FilterConfigState>()(
  persist(
    (set, get) => ({
      favorites: JSON.parse(localStorage.getItem('filterFavorites') || 'false'),
      type: JSON.parse(localStorage.getItem('filterType') || '[]'),
      status: JSON.parse(localStorage.getItem('filterStatus') || '[]'),
      incidence: JSON.parse(localStorage.getItem('filterIncidence') || '[]'),
      setIncidence: (incidence: number) => {
        const incidences = get().incidence;
        const exist = incidences.includes(incidence);
        let newIncidences = [...incidences];

        if(exist) {
          newIncidences = newIncidences.filter((it) => it !== incidence);
        } else {
          newIncidences.push(incidence);
        }

        localStorage.setItem('filterIncidence', JSON.stringify(newIncidences));
        set({ incidence: newIncidences });
      },
      setFavorites: (option: boolean) => {
        localStorage.setItem('filterFavorites', JSON.stringify(option));
        set({ favorites: option });
      },
      setType: (type: string) => {
        const types = get().type;
        const exist = types.includes(type);  

        let newTypes = [...types];

        if(exist) {
          newTypes = newTypes.filter((it) => it !== type);
        } else {
          newTypes.push(type);
        }

        localStorage.setItem('filterType', JSON.stringify(newTypes));
        set({ type: newTypes });
      },
      setStatus: (status: string) => {
        const statuses = get().status;
        const exist = statuses.includes(status);  
        let newStatus = [...statuses];

        if(exist) {
          newStatus = newStatus.filter((it) => it !== status);
        } else {
          newStatus.push(status);
        }

        localStorage.setItem('filterStatus', JSON.stringify(newStatus));
        set({ status: newStatus });
      },
      resetFilters: () => {
        set({
          status: [],
          type: [],
          favorites: false,
          incidence: []
        })

        localStorage.removeItem('filterStatus');
        localStorage.removeItem('filterType');
        localStorage.removeItem('filterFavorites');
        localStorage.removeItem('filterIncidence');
      },
      resetOnChange: () => set({
        status: [],
        incidence: []
      })
    }),
    {
      name: 'disciplines-filter-config',
    }
  )
);